import React from 'react';
import markas from '../assets/vavelle-main-image.webp'; // Import the logo image
function TentangKami() {
  return (<>
  <section className="relative py-16 bg-center" style={{
    backgroundImage: "url('https://millionmilesecrets.com/wp-content/uploads/2016/04/Do_You_Still_Get_Primary_Rental_Car_Insurance_When_You_Use_Chase_Ultimate_Rewards_Points_To_Pay_For_Your_Rental_01.jpg')",
    backgroundSize: 'cover',
    height:'400px'
  }}>
    <div className="absolute inset-0 bg-black opacity-50"></div>
    <div className="relative flex items-center justify-center h-full px-4 text-center text-white">
      <div>
        <h1 className="text-3xl font-bold mb-4">Tentang Kami</h1>
        <p className="text-lg">
        Sejak 2011, Vavelle & Co Rental Mobil telah melayani pelanggan lokal, regional, dan internasional. Kami adalah perusahaan persewaan milik lokal di Jakarta, Indonesia. Penyewaan mobil di Jabodetabek tidak pernah semudah ini dengan Excellence Car Rental. Kami menawarkan layanan, pilihan, dan harga yang kompetitif. Excellence Car Rental adalah perusahaan persewaan mobil terkemuka di Jabodetabek yang mana kami percaya pada layanan pelanggan yang sangat baik dan memenuhi kebutuhan pelanggan kami. Pilihan kami meliputi mobil Mewah, Ukuran Sedang, Van, SUV, dan Ukuran Penuh untuk disewa.

Kami menawarkan harga yang kompetitif, diskon pelanggan, dan layanan pelanggan yang sangat baik. Kami fokus untuk memastikan bahwa setiap pelanggan menikmati pengalaman sewa mereka dan tinggal di sini di Jabodetabek.

Fokus kami adalah untuk selalu memenuhi permintaan dan kepuasan pelanggan kami setiap saat.          
        </p>
      </div>
    </div>
  </section>
<section className="py-16 px-4 lg:px-8">
  <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">
    {/* <!-- Left Column --> */}
    <div className="text-lg">
      <p>Kami menawarkan kepada pelanggan berbagai macam mobil niaga dan mobil mewah untuk berbagai acara.</p>
    </div>

    {/* <!-- Right Column --> */}
    <div className="text-lg">
      <p>Saya memulai Vavelle & Co Rental Mobil untuk melayani masyarakat setempat. Saya melihat bahwa perusahaan persewaan lain menawarkan layanan yang buruk dan kurang memahami daerah kami. Mereka tidak mengenal orang-orang yang mereka layani. Di Vavelle & Co Rental Mobil, kami mengenal Anda, Anda adalah tetangga kami. Kami menginginkan yang terbaik untuk Anda dan itulah sebabnya Anda berhak mendapatkan layanan yang jujur, adil, dan sederhana. Kami siap memenuhi semua kebutuhan Anda, bahkan kebutuhan di luar persewaan mobil. Selamat datang di keluarga kami!</p>
    </div>
  </div>
</section>
<section className="text-white text-lg" style={{backgroundColor: '#cc0000'}}>
  <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">
    {/* Left Column */}
    <div className="py-16 px-4 lg:px-8 text-lg flex items-center justify-center">
      <div>
        <h3 className="text-xl font-bold mb-4 text-center">Sepatah kata</h3>
        <p className="text-center">Saya memulai Vavelle & Co Rental Mobil untuk melayani masyarakat setempat. Saya melihat bahwa perusahaan persewaan lain menawarkan layanan yang buruk dan kurang memahami daerah kami. Mereka tidak mengenal orang-orang yang mereka layani. Di Vavelle & Co Rental Mobil, kami mengenal Anda, Anda adalah tetangga kami. Kami menginginkan yang terbaik untuk Anda dan itulah sebabnya Anda berhak mendapatkan layanan yang jujur, adil, dan sederhana. Kami siap memenuhi semua kebutuhan Anda, bahkan kebutuhan di luar persewaan mobil. Selamat datang di keluarga kami!</p>
      </div>
    </div>

    {/* Right Column */}
    <div className="flex items-center justify-center">
      <img 
        src={markas}
        alt="Vavelle & Co Rental Mobil Founder"
        className="w-full object-cover h-full"
      />
    </div>
  </div>
</section>
<section className="max-w-7xl mx-auto px-4 lg:px-8 text-lg">
    <div className="h-20"></div>
    <div class="container mx-auto px-4">
    <div class="flex flex-wrap -mx-4">
      <div class="w-full md:w-1/2 xl:w-1/2 px-4 mb-4">
        <h2 class="text-2xl font-bold mb-2">Visi</h2>
        <p class="text-lg leading-relaxed">Menjadi penyedia jasa rental mobil terpercaya dan unggul di Indonesia, memberikan pengalaman yang tak terlupakan bagi pelanggan kami.</p>
      </div>
      <div class="w-full md:w-1/2 xl:w-1/2 px-4 mb-4">
        <h2 class="text-2xl font-bold mb-2">Misi</h2>
        <ul class="list-disc pl-4">
          <li class="mb-2">Menyediakan armada mobil yang terawat dan nyaman untuk memenuhi kebutuhan pelanggan.</li>
          <li class="mb-2">Memberikan pelayanan yang ramah, profesional, dan responsif untuk memastikan kepuasan pelanggan.</li>
          <li class="mb-2">Mengembangkan jaringan kerja sama dengan berbagai pihak untuk memperluas jangkauan layanan kami.</li>
          <li class="mb-2">Meningkatkan kualitas layanan kami secara terus-menerus untuk memenuhi harapan pelanggan.</li>
          <li class="mb-2">Menjadi bagian dari momen spesial pelanggan kami, seperti pernikahan, wisuda, dan acara lainnya.</li>
        </ul>
      </div>
    </div>
  </div>

        <div className="h-20"></div>
        </section>
</>
  );
};

export default TentangKami;